/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/card';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "ActivateCardRequest": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "expiryDate": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "securityCode": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "manualEntry": {
                    "type": "squareup.corporate_card.service.ActivateCardRequest.ManualEntry",
                    "id": 4
                  },
                  "deepLink": {
                    "type": "squareup.corporate_card.service.ActivateCardRequest.DeepLink",
                    "id": 5
                  }
                },
                "nested": {
                  "ManualEntry": {
                    "fields": {
                      "expiryDate": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "securityCode": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "DeepLink": {
                    "fields": {
                      "carrierId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "cardReferenceNumber": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "activation_method": {
                    "oneof": ["manualEntry", "deepLink"]
                  }
                }
              },
              "ActivateCardResponse": {
                "fields": {
                  "card": {
                    "type": "squareup.corporate_card.resources.Card",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": "squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "status": {
                    "type": "squareup.corporate_card.service.ActivateCardResponse.Status",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Status": {
                    "values": {
                      "S_DO_NOT_USE": 0,
                      "SUCCESS": 1,
                      "INVALID_CVV": 2,
                      "INVALID_EXPIRATION_DATE": 3,
                      "BAD_CVV_ATTEMPT_EXCEEDED": 4,
                      "INVALID_CARD_REFERENCE_NUMBER": 5
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ActivateCardRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ActivateCardRequest?.nested?.ManualEntry && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ActivateCardRequest?.nested?.DeepLink && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ActivateCardResponse && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ActivateCardResponse?.nested?.Status) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ActivateCardRequest @ squareup/corporate_card/service/activate_card.proto at 12:1
 */
export const ActivateCardRequest = $root.lookupType('squareup.corporate_card.service.ActivateCardRequest');
fixType(ActivateCardRequest, {
  id: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ActivateCardRequest);
/**
 * Submitted manually-entered values to be compared against the actual value.
 *
 * SOURCE ManualEntry @ squareup/corporate_card/service/activate_card.proto at 39:3
 */
ActivateCardRequest.ManualEntry = $root.lookupType('squareup.corporate_card.service.ActivateCardRequest.ManualEntry');
fixType(ActivateCardRequest.ManualEntry, {
  expiryDate: {
    notEmpty: true
  },
  securityCode: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ActivateCardRequest.ManualEntry);
/**
 * Params from the QR code on the physical credit card's mailer.
 *
 * SOURCE DeepLink @ squareup/corporate_card/service/activate_card.proto at 52:3
 */
ActivateCardRequest.DeepLink = $root.lookupType('squareup.corporate_card.service.ActivateCardRequest.DeepLink');
fixType(ActivateCardRequest.DeepLink, {
  cardReferenceNumber: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ActivateCardRequest.DeepLink);
/**
 * SOURCE ActivateCardResponse @ squareup/corporate_card/service/activate_card.proto at 60:1
 */
export const ActivateCardResponse = $root.lookupType('squareup.corporate_card.service.ActivateCardResponse');
fixType(ActivateCardResponse, {
  status: {
    required: true
  }
});
Builder.createAndAttachToType(ActivateCardResponse);
/**
 * SOURCE Status @ squareup/corporate_card/service/activate_card.proto at 61:3
 */
ActivateCardResponse.Status = $root.lookupEnum('squareup.corporate_card.service.ActivateCardResponse.Status').values;